import { ShowErrorDialogPayload } from 'store/errorDialog/actions.types';
import {
    DISMISS_ERROR_DIALOG,
    SHOW_ERROR_DIALOG,
} from 'store/errorDialog/constants';

export function showErrorDialog(payload: ShowErrorDialogPayload) {
    return {
        type: SHOW_ERROR_DIALOG,
        payload,
    };
}

export function dismissErrorDialog() {
    return {
        type: DISMISS_ERROR_DIALOG,
    };
}
